
import * as React from "react";
import { Api } from "../../../lib/Api";
import DateTool from "../../../../avernus/datetool/source/DateTool";

export interface IItem {
    id             : number
    name           : string
}


interface IXHR{
    error   :string
    success :string
}

interface IHolidayBoxProps {
    id                          : number
    xhrGetItems                 : string
    xhrAdd                      : string
    xhrRemove                   : string
}
interface IForm{
    fromDate: string
    toDate  : string
}

interface ISaveData extends IForm{
    id: number
}

interface IHolidayBoxState {
    error       : string
    success     : string
    form        : IForm
    items       : Array<ISaveData>
}


interface IgetItems{
    items          : Array<ISaveData>
}


export default class HolidayBox extends React.Component<IHolidayBoxProps, IHolidayBoxState>{

  	constructor(props:IHolidayBoxProps){
        super(props);
        this.state = {
            success     : null,
            error       : null,
            items       : null,
            form        : this.getFormDefaultValue()
		};
        this.init();
    }

    private init(){
        this.getItems();
    }

    private getFormDefaultValue(): IForm {
        return {
            fromDate: '',
            toDate  : ''
        }
    }

    private getItems(){
        Api.call(this.props.xhrGetItems, {
            restaurantId  : this.props.id
        }, (result:IgetItems)=>{
            this.setState({
                items: result.items
            });
        });
    }

    private removeItemClickHandler(evt, connectId:number): void {
        evt.preventDefault();
        Api.call(this.props.xhrRemove, {
            connectId     : connectId,
            restaurantId  : this.props.id
        }, (result:IXHR)=>{
            this.setState({
                success: result.success,
                error  : result.error
            }, ()=>{
                this.getItems();
            });
        });
    }

    private changeInputHandler(evt, type:string): void {
        evt.preventDefault();
        var form    = this.state.form;
        form[type]  = DateTool.getDate(evt.target.value);
        this.setState({
            form: form
        });
    }

    private submitHandler(evt?): void {
        if ( evt !== undefined ) {
            evt.preventDefault();
        }
            Api.call(this.props.xhrAdd, {
                fromDate        : this.state.form.fromDate,
                toDate          : this.state.form.toDate,
                restaurantId    : this.props.id,
            }, (result:IXHR)=>{
            this.setState({
                 success: result.success,
                 error  : result.error,
                 form   : {
                     fromDate   : '',
                     toDate     : ''
                 }
            }, ()=>{
                this.getItems();
            });
        });
    }

    private closedForTodayClickHandler(evt): void {
        evt.preventDefault();
        let from = {
            fromDate: DateTool.getDate(),
            toDate: DateTool.getDate()
        };
        this.setState({
             form: from
        }, () =>{
            this.submitHandler();
        });

    }


    render() {
        let datesIsValided:boolean = false;
        return (
            <>
                <form onSubmit={ e => this.submitHandler(e) } className="holiday_form">
                    <div className="row">
                        <div className="col-xl-12" style={{marginTop: '15px'}}>
                             <div className="form-row">
                                <div className="col-5 col-date">
                                    <input className="s-form-control" type="date" required={true} name="fromDate" value={this.state.form.fromDate} onChange={ e => this.changeInputHandler(e,'fromDate') } max={this.state.form.fromDate}
                                    />
                                </div>
                                <div className="col-5 col-date">
                                    <input className="s-form-control" type="date" required={true} name="toDate" value={this.state.form.toDate} onChange={ e => this.changeInputHandler(e,'toDate') } min={this.state.form.fromDate}
                                    />
                                </div>
                                <div className="col-2 add_holiday_btn">
                                     <button className="green_btn" id="add_holiday_btn" disabled={datesIsValided} type="submit"><i className="icon ion-plus"/></button>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12">
                            { this.state.error !== null?<div className="alert alert-danger" style={{marginTop:'10px'}}>
                                    { this.state.error }
                            </div>:''}
                            { this.state.success !== null?<div className="alert alert-success" style={{marginTop:'10px'}}>
                                    { this.state.success }
                            </div>:''
                            }
                        </div>
                    </div>
                </form>

                <div className="row">
                    <div className="col-xl-12" style={{margin: '15px 0'}}>
                        { this.state.items !== null?<div className="table-responsive gray_table">
                            <table className="table table-striped table-sm">
                                <tbody>
                                    { this.state.items.map((item, index) =>{
                                        return <tr className = "holiday_tr" key={index}>
                                            {
                                                item.fromDate == item.toDate?
                                                <td>
                                                    { DateTool.convertDateToUSADate(item.fromDate) }
                                                </td>:
                                                <td>
                                                    { DateTool.convertDateToUSADate(item.fromDate) } - { DateTool.convertDateToUSADate(item.toDate) }
                                                </td>
                                            }
                                            <td className="sya">Closed</td>

                                            <td className="closed_td">
                                                <button className={'u_trash remove_holiday_btn ' + ((this.state.items.length-1)===index?'last':'') } type="button" onClick={ e => this.removeItemClickHandler(e, item.id) }
                                                >
                                                </button>
                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </table>
                        </div>:'Loading ...' }
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <button className="red_btn" id="close_today_save_btn" type="button" onClick={ e => this.closedForTodayClickHandler(e) }
                        >Closed today</button>
                    </div>
                </div>

			</>
        );
    }
}
